import React from 'react';
import {
  Box,
  Typography,
  // Button,
  // Card,
  // CardContent,
  // Link
} from '@mui/material';
import { YouTubeContent1 } from '../resources/YouTubeContent';
//import { useNavigate } from 'react-router-dom';


export const DrArturoExplains: React.FC = () => {
  return (
    <Box
      sx={{
        width: "100%",
        py: 3
      }}
    >
      <Typography
        variant="h5"        
        fontWeight="bold"
        sx={{ mb: 3 }}
      >
        Dr. Arturo explains:
      </Typography>

      <Typography
        variant="h7"
        
        fontWeight="bold"
        sx={{ mb: 3 }}
    >
        What Are Clinical Trials?
      </Typography>

      <Typography variant="body1" sx={{mb: 3}}>
        Cancer is an unfortunate reality that touches most of us at some point in our lives. If you or a loved one has cancer, you may have heard or read that clinical trials could offer access to innovative new options. But what exactly is a clinical trial? In this video, Dr. Arturo Loaiza-Bonilla, MD, explains how clinical trials work, what to expect if you enroll in one, and why a clinical trial can be an important option for many cancer patients.
      </Typography>
      <YouTubeContent1 videoId={'UgZG1ZuVQs4?si=ltJjtFBhPkcK0kQk'} title={''} description={''} isPlaying={false} />
    </Box>
  );
};

// Export using export const syntax